import React from 'react';

const AssetManagement = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-4xl font-bold">Asset Management</h1>
    </div>
  );
};

export default AssetManagement;
